module.exports = __webpack_public_path__ + "static/logo-df302290595c9d1d89037e681cdfb428.png";